<app-layout>
   
    <admin-reports-tab :referrer="filters.referrer" section="staking"></admin-reports-tab>   
 
    <h1 class="mt-10 mb-8 font-bold text-3xl">
        <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('admin.users.edit', filters.referrer)" v-if="filters.referrer">Go Back - </inertia-link> Staking-Transactions
    </h1>

    <div class="mb-6 flex justify-between items-center">
        <search-filter v-model="form.search" class="w-full max-w-md mr-4 focus:outline-none" @reset="reset"></search-filter>
    </div>


    <div class="bg-white rounded shadow overflow-x-auto">
        <table class="w-full whitespace-no-wrap">
            <tr class="text-left font-bold">
                <th class="px-3 pt-6 pb-4">Tx ID</th>
                <th class="px-3 pt-6 pb-4">Amount</th>
                <th class="px-3 pt-6 pb-4">User</th>
                <th class="px-3 pt-6 pb-4">Period (Days)</th>
                <th class="px-3 pt-6 pb-4">APY</th>
                <th class="px-3 pt-6 pb-4">Reward</th>
                <th class="px-3 pt-6 pb-4">Date</th>
            </tr>
            <tr v-for="transaction in transactions.data" :key="transaction.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                <td class="border-t">
                    <span class="px-3 py-2 flex items-center">
                        {{ transaction.id }}
                    </span>
                </td>
                <td class="border-t">
                    <span class="px-3 py-2 flex items-center">
                        {{ transaction.amount }} {{ transaction.currency.symbol }}
                    </span>
                </td>

                <td class="border-t">
                    <span class="px-3 py-2 flex items-center">
                        {{ transaction.user.email }}
                    </span>
                </td>
                <td class="border-t">
                    <span class="px-3 py-2 flex items-center">
                        {{ transaction.days }}
                    </span>
                </td>
                <td class="border-t">
                    <span class="px-3 py-2 flex items-center">
                        {{ transaction.apy }}
                    </span>
                </td>
                <td class="border-t">
                    <span class="px-3 py-2 flex items-center">
                        {{ transaction.reward }} {{ transaction.currency.symbol }}
                    </span>
                </td>
                <td class="border-t">
                    <span class="px-3 py-2 flex items-center">
                        {{ transaction.status }}
                    </span>
                </td>
                <td class="border-t">
                    <span class="px-3 py-2 flex items-center">
                        {{ transaction.created_at }}
                    </span>
                </td>
            </tr>
            <tr v-if="transactions.data.length === 0">
                <td class="border-t px-3 py-2" colspan="100">No transactions found.</td>
            </tr>
        </table>
    </div>
    <pagination :links="transactions.links" />
</app-layout>
